import { Alert } from "flowbite-react";
import { CircleAlert } from "lucide-react";
import { LEGAL_COMPLIANCE_COPY } from "@/features/legal/config/legal.config";

export const LegalComplianceRefusalAlert = () => (
  <Alert color="warning" icon={CircleAlert} role="alert" data-testid="legal-compliance-refusal-alert">
    {LEGAL_COMPLIANCE_COPY.REFUSAL_MESSAGE}
  </Alert>
);

LegalComplianceRefusalAlert.displayName = "LegalComplianceRefusalAlert";
